/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hc_Domains_Step_1Inputs */

const en_hc_domains_step_1 = /** @type {(inputs: Hc_Domains_Step_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claim a new domain. Search for a name priced under $15.00 and provision it instantly. We handle the DNS for you.`)
};

const es_hc_domains_step_1 = /** @type {(inputs: Hc_Domains_Step_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reclama un nuevo dominio. Busca un nombre con precio inferior a $15.00 y configúralo al instante. Nosotros nos encargamos del DNS.`)
};

const fr_hc_domains_step_1 = /** @type {(inputs: Hc_Domains_Step_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réclamez un nouveau domaine. Recherchez un nom à moins de 15,00 $ et configurez-le instantanément. Nous nous occupons du DNS pour vous.`)
};

const de_hc_domains_step_1 = /** @type {(inputs: Hc_Domains_Step_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beanspruche eine neue Domain. Suche nach einem Namen unter 15,00 $ und stelle ihn sofort bereit. Wir übernehmen das DNS für dich.`)
};

/** @type {(inputs: Hc_Domains_Step_1Inputs) => LocalizedString} */
const ja_hc_domains_step_1 = en_hc_domains_step_1;

/** @type {(inputs: Hc_Domains_Step_1Inputs) => LocalizedString} */
const zh_hc_domains_step_1 = en_hc_domains_step_1;

/** @type {(inputs: Hc_Domains_Step_1Inputs) => LocalizedString} */
const ar_hc_domains_step_1 = en_hc_domains_step_1;

/** @type {(inputs: Hc_Domains_Step_1Inputs) => LocalizedString} */
const id_hc_domains_step_1 = en_hc_domains_step_1;

/** @type {(inputs: Hc_Domains_Step_1Inputs) => LocalizedString} */
const it_hc_domains_step_1 = en_hc_domains_step_1;

/** @type {(inputs: Hc_Domains_Step_1Inputs) => LocalizedString} */
const ru_hc_domains_step_1 = en_hc_domains_step_1;

/** @type {(inputs: Hc_Domains_Step_1Inputs) => LocalizedString} */
const pt_hc_domains_step_1 = en_hc_domains_step_1;

/** @type {(inputs: Hc_Domains_Step_1Inputs) => LocalizedString} */
const ko_hc_domains_step_1 = en_hc_domains_step_1;

/**
* | output |
* | --- |
* | "Claim a new domain. Search for a name priced under $15.00 and provision it instantly. We handle the DNS for you." |
*
* @param {Hc_Domains_Step_1Inputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const hc_domains_step_1 = /** @type {((inputs?: Hc_Domains_Step_1Inputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hc_Domains_Step_1Inputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hc_domains_step_1(inputs)
	if (locale === "es") return es_hc_domains_step_1(inputs)
	if (locale === "fr") return fr_hc_domains_step_1(inputs)
	if (locale === "de") return de_hc_domains_step_1(inputs)
	if (locale === "ja") return ja_hc_domains_step_1(inputs)
	if (locale === "zh") return zh_hc_domains_step_1(inputs)
	if (locale === "ar") return ar_hc_domains_step_1(inputs)
	if (locale === "id") return id_hc_domains_step_1(inputs)
	if (locale === "it") return it_hc_domains_step_1(inputs)
	if (locale === "ru") return ru_hc_domains_step_1(inputs)
	if (locale === "pt") return pt_hc_domains_step_1(inputs)
	return ko_hc_domains_step_1(inputs)
});